// Select1PropertyValuePopover.tsx
import { Box, List, ListItemButton, ListItemText, Typography } from '@mui/material'
import { useMemo, useState } from 'react'
import { Select1OptionListItem } from 'objects/property-forms/select-1/Select1OptionListItem.tsx'
import { useDiRef } from '@/common/react/di-hooks.ts'
import type { ObjectTypesService } from '@/object-types/services/ObjectTypesService.ts'
import { SelectPropertyPopoverSearch } from 'objects/property-forms/select-1/SelectPropertyPopoverSearch.tsx'
import type { PropertyDefinitionModel } from '@/core/gql/gql-models-override.ts'
import type { PropertyOptionModel } from '@/generated/graphql.ts'

export interface Select1ValueSetEditPopoverProps {
  setPopoverResult: (selectedValue: PropertyOptionModel | null) => void
  propDef: PropertyDefinitionModel
}

export function Select1PropertyValuePopover({
  setPopoverResult,
  propDef,
}: Select1ValueSetEditPopoverProps) {
  const typesService = useDiRef<ObjectTypesService>('ObjectTypesService')
  const [searchText, setSearchText] = useState('')
  const [options, setOptions] = useState(propDef.options!)
  const [newOption, setNewOption] = useState(() =>
    typesService.createLocalPropertyOption(propDef, { value: searchText }),
  )
  newOption.value = searchText

  const filteredOptions = useMemo(() => {
    const lower = searchText.toLowerCase()
    return options.filter((opt) => opt.value.toLowerCase().includes(lower))
  }, [searchText, options])

  function onNewOptionCreatedAndSelected() {
    const newOptionValue = searchText.trim()
    if (!newOptionValue) return
    onOptionSelected(newOption)
    // setNewOption(typesService.createLocalPropertyOption(propDef, { value: newOptionValue }))
    // setSearchText('')
  }

  function onOptionSelected(option: PropertyOptionModel | null) {
    setPopoverResult(option)
  }

  return (
    <Box sx={{ minWidth: 240, backgroundColor: 'transparent' }}>
      <SelectPropertyPopoverSearch
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        onSubmit={onNewOptionCreatedAndSelected}
      />

      <Typography variant="body2" color="text.secondary" textAlign="left" paddingLeft={'1rem'}>
        Select an option
      </Typography>

      <List disablePadding>
        {filteredOptions.map((option) => (
          <Select1OptionListItem
            key={option.id}
            option={option}
            onClick={() => onOptionSelected(option)}
          />
        ))}

        <ListItemButton onClick={() => onOptionSelected(null)}>
          <ListItemText primary="Clear" />
        </ListItemButton>

        {searchText.trim() &&
          !options.some((opt) => opt.value.toLowerCase() === searchText.trim().toLowerCase()) && (
            <Select1OptionListItem
              label="Create:"
              option={newOption}
              onClick={() => onOptionSelected(newOption)}
            />
          )}
      </List>
    </Box>
  )
}
